export default __webpack_public_path__ + "static/media/people.f328c4e8.jpg";